import { Button } from "primereact/button";
import PageTitle from "../components/common/PageTitle";
import TabHeader from "../components/common/TabHeader";
import { Divider } from "primereact/divider";
import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "../providers/ProviderAppContainer";
import Loading from "../components/common/Loading";
import NoContent from "../components/common/NoContent";
import DialogAddBranch from "../components/manage_branches/DialogAddBranch";
import Branch from "../components/manage_branches/Branch";
import { AUTHORITIES } from "../constants";
import HasRequiredAuthority from "../components/dependencies/HasRequiredAuthority";

export default function ManageBranches() {
    const { requestAPI } = useAppContext();

    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [branches, setBranches] = useState();

    const [dialogAddBranch, setDialogAddBranch] = useState({
        visible: false,
    });

    const closeDialogAddBranch = useCallback(() => {
        setDialogAddBranch((prev) => ({ ...prev, visible: false }));
    }, []);

    useEffect(() => {
        requestAPI({
            requestPath: `branches`,
            requestMethod: "GET",
            setLoading: setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (data && responseCode === 200) {
                    setBranches(data);
                } else {
                    setError("Couldn't load Branches");
                }
            },
        });
    }, [requestAPI]);

    return (
        <div className="flex flex-column h-full">
            <PageTitle title="Branches" />
            <TabHeader
                className="px-3 pt-3"
                title="Manage Branches"
                highlights={[`Add / Edit / Delete Branches`, `Green = Active, Red = Inactive`]}
                actionItems={[
                    <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_BRANCH}>
                        <Button
                            icon="pi pi-plus"
                            severity="warning"
                            onClick={() =>
                                setDialogAddBranch((prev) => ({
                                    ...prev,
                                    setBranches,
                                    visible: true,
                                    closeDialog: closeDialogAddBranch,
                                }))
                            }
                        />
                    </HasRequiredAuthority>,
                ]}
            />
            <Divider />
            {loading ? (
                <Loading />
            ) : error ? (
                <NoContent error={error} />
            ) : (
                <div className="flex-1 overflow-hidden flex flex-column gap-2 p-2 overflow-y-scroll">
                    {branches?.length ? branches.map((branch) => <Branch key={branch?.id} {...branch} setBranches={setBranches} />) : <NoContent />}
                </div>
            )}

            {dialogAddBranch?.visible && <DialogAddBranch {...dialogAddBranch} />}
        </div>
    );
}
